import * as AppointmentActionTypes from '../actionTypes/AppointmentActionTypes';

export const getAppointmentLink = (selectedService, stores) => ({
    type: AppointmentActionTypes.GET_APPOINTMENT_LINK,
    payload: {
        service: 'decorating,sephora,salon,stylingroom,stylesubstance,barbery',
        stores,
    },
    selectedService,
});

export const appointmentPageLoaded = () => ({
    type: AppointmentActionTypes.MY_APPOINTMENTS_PAGE_LOADED_SUCCESS,
    payload: {},
});
